const t = {
  textVariant: "light",
  rejectButtonVariant: "decision",
  manageButtonVariant: "secondaryLink"
};
export {
  t as default
};
